import { useQuery } from '@tanstack/react-query';
import API from 'services/api/index';
import QUERY_KEYS from 'services/api/queryKeys';

export const useGetCampaigns = () => {
  const { data, status, isLoading, isFetching } = useQuery({
    queryKey: [QUERY_KEYS.GET_CAMPAIGNS],
    queryFn: API.common.getCampaigns
  });

  return {
    data,
    status,
    isLoading,
    isFetching
  };
};
